$.fn.ledgerEditClickEvent = function () {
  const isInLedgerPage = $("#ledgerTable").length > 0;
  if (!isInLedgerPage) {
    return;
  }

  const urlWithoutLedgerCodeId = window.location.href
      .replace(/#.*/, '') // remove fragment
      .replace(/&ledger-code-id=[^&]*/,''); // remove ledger-code-id query param. Assumes it is not the first query param

  function hideErrors() {
    $('.govuk-form-group--error').removeClass('govuk-form-group--error');
    $('.govuk-error-summary').hide();
    $(".govuk-error-message").hide();
  }

  function populateFormUsingTableRow(row) {
    const grantSectionCode = row.find('.ledger-code__grant-section-code').text();
    $("#grantSectionCode").val(grantSectionCode).trigger("chosen:updated");

    const accountType = row.find('.ledger-code__account-type').text();
    $("#accountType").val(accountType).trigger("chosen:updated");

    const accountNumber = row.find(".ledger-code__account-number").text();
    $("#accountNumber").val(accountNumber);
    $("#accountNumber").text(accountNumber);
    const glAccountCode = row.find(".ledger-code__gl-account-code").text();
    $("#glAccountCode").val(glAccountCode);
    $("#glAccountCode").text(glAccountCode);

    const wbsCode = row.find(".ledger-code__wbs-code").text();
    $("#wbsCode").val(wbsCode);
    $("#wbsCode").text(wbsCode);

    const destinationCode = row.find('.ledger-code__destination-code').text();
    $("#destinationCode").val(destinationCode);
    $("#destinationCode").text(destinationCode);
    const destinationType = row.find('.ledger-code__destination-type').text();
    $('#destinationType').val(destinationType).trigger('chosen:updated');
  }

  function editHandler(event, skipPopulatingForm) {
    const row = $(this).closest("tr");
    if (!skipPopulatingForm) {
      hideErrors();
      populateFormUsingTableRow(row);
    }
    row.hide();

    $("#grantSectionCode").children("option").hide();
    $('#grantSectionCode option:selected').show();
    $('#grantSectionCode').trigger("chosen:updated");
    $("#accountType").children("option").hide();
    $('#accountType option:selected').show();
    $('#accountType').trigger("chosen:updated");

    $('#edit_ledger_code').text('Edit ledger code');
    $(".chosen-search").hide();
    $(".edit-btn").prop("disabled", true);
    $(".remove-btn").prop("disabled", true);

    window.history.pushState(
        null,
        "",
        urlWithoutLedgerCodeId + "&ledger-code-id=" + row.find('.ledger-code__uuid').text(),
    );
    window.scrollTo(0, $("tfoot").offset().top);
  }

  function cancelHandler() {
    const rowThatWasBeingEdited = $('#ledgerTable tbody tr:hidden');
    if (rowThatWasBeingEdited.length) {
      rowThatWasBeingEdited.show();
      window.scrollTo(0, rowThatWasBeingEdited.offset().top);
    }

    $('#edit_ledger_code').text('Add ledger code');
    $("select option:selected").removeAttr("selected");
    $("#grantSectionCode").children("option").show();
    $("#accountType").children("option").show();
    $(".form-control").val("");
    $(".chosen-search").show();
    $(".chosen-select").val("").trigger("chosen:updated");
    $(".edit-btn").prop("disabled", false);
    $(".remove-btn").prop("disabled", false);
    hideErrors();
    window.history.pushState(null, "", urlWithoutLedgerCodeId);
  }

  $(".edit-btn").each(function (index, editButton) {
    $(editButton).on('click', editHandler);
    if (editButton.getAttribute('data-autotrigger') === 'true') {
      $(editButton).trigger('click', true);
    }
  });
  $("#cancelEdit").on('click', cancelHandler);
};
